import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=e9d9b0be&"
import script from "./DefaultButton.vue?vue&type=script&lang=js&"
export * from "./DefaultButton.vue?vue&type=script&lang=js&"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports